import { render, staticRenderFns } from "./basicDataSetting.vue?vue&type=template&id=271ff175&scoped=true&"
import script from "./basicDataSetting.vue?vue&type=script&lang=js&"
export * from "./basicDataSetting.vue?vue&type=script&lang=js&"
import style0 from "./basicDataSetting.vue?vue&type=style&index=0&id=271ff175&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271ff175",
  null
  
)

export default component.exports